import React, { useEffect, useRef } from 'react';
import { Text, Group } from 'react-konva';
import { NEON_COLORS, NEON_FONTS } from '../../../constants/options';

const TextManager = ({
  CANVAS_WIDTH,
  texts,
  setTexts,
  selectedTextId,
  setSelectedTextId,
  fontLoaded
}) => {
  const textRefs = useRef({});
  const transformerRef = useRef(null);

  useEffect(() => {
    const loadFonts = async () => {
      const fontPromises = NEON_FONTS.map(font => {
        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.href = font.url;
          link.rel = 'stylesheet';
          link.onload = resolve;
          link.onerror = reject;
          document.head.appendChild(link);
        });
      });

      try {
        await Promise.all(fontPromises);
      } catch (error) {
        console.error('Error loading fonts:', error);
      }
    };

    loadFonts();
  }, []);

  // Actualizar Transformer cuando cambia el texto seleccionado
  useEffect(() => {
    if (selectedTextId && transformerRef.current) {
      const selectedNode = textRefs.current[selectedTextId];
      if (selectedNode) {
        transformerRef.current.nodes([selectedNode]);
        transformerRef.current.getLayer().batchDraw();
      }
    }
  }, [selectedTextId, texts]);

  if (!fontLoaded) return null;

  const handleTextClick = (id) => {
    setSelectedTextId(id);
  };

  const handleDeleteText = (id) => {
    setTexts((prev) => prev.filter((text) => text.id !== id));
    setSelectedTextId(null);
  };

  const handleDragMoveText = (e, textId) => {
    const { x, y } = e.target.position();
    setTexts(prev =>
      prev.map(text =>
        text.id === textId ? { ...text, x, y } : text
      )
    );
  };

  return (
    <>
      {texts.map((textObj) => {
        const neonColor = NEON_COLORS.find(color => color.value === textObj.color) || NEON_COLORS[0];

        if (!textRefs.current[textObj.id]) {
          textRefs.current[textObj.id] = React.createRef();
        }

        const groupRef = textRefs.current[textObj.id];
        const textConfig = {
          text: textObj.text,
          x: textObj.x,
          y: textObj.y,
          fontSize: textObj.fontSize,
          fontFamily: textObj.fontFamily,
          align: 'center',
          draggable: true,
          wrap: 'word',
          width: CANVAS_WIDTH - 40,
        };

        return (
          <Group
            key={textObj.id}
            ref={groupRef}
            onDragMove={(e) => handleDragMoveText(e, textObj.id)}
            onClick={() => handleTextClick(textObj.id)}
            draggable
          >
            {/* Capa de resplandor exterior */}
            <Text
              {...textConfig}
              fill={neonColor.glow[0]}
              shadowColor={neonColor.glow[0]}
              shadowBlur={40}
              shadowOffset={{ x: 0, y: 0 }}
              opacity={0.8}
            />
            {/* Capa de resplandor medio */}
            <Text
              {...textConfig}
              fill={neonColor.glow[1]}
              shadowColor={neonColor.glow[1]}
              shadowBlur={25}
              shadowOffset={{ x: 0, y: 0 }}
              opacity={0.9}
            />
            {/* Capa de texto principal */}
            <Text
              {...textConfig}
              fill={neonColor.value}
              shadowColor={neonColor.glow[2]}
              shadowBlur={10}
              shadowOffset={{ x: 0, y: 0 }}
              opacity={1}
            />

            {/* Ícono de basura */}
            {selectedTextId === textObj.id && (
              <Text
                text="🗑️"
                x={textObj.x + 50}
                y={textObj.y - 20}
                fontSize={20}
                onClick={(e) => {
                  e.cancelBubble = true;
                  handleDeleteText(textObj.id);
                }}
                fill="red"
                cursor="pointer"
              />
            )}
          </Group>
        );
      })}
    </>
  );
};

export default TextManager;